import BaseRoute from 'uplisting-frontend/pods/base/route';
import type NoAccessController from 'uplisting-frontend/pods/no-access/controller';

export default class NoAccessRoute extends BaseRoute {
  resetController(controller: NoAccessController, isExiting: boolean): void {
    if (isExiting) {
      controller.denied = null;
      controller.reason = null;
    }
  }
}
